import { Image, ImageProps, Row } from 'antd';

/* eslint-disable jsx-a11y/media-has-caption */
interface Props extends ImageProps {
  imageUrl: string;
}

export default function QuestionImage({ imageUrl, ...props }: Props) {
  if (!imageUrl) return null;
  return (
    <Row className='mb-4' justify='center'>
      <Image key={imageUrl} src={imageUrl} alt={imageUrl} style={{ height: 220, ...props.style }} className={`tw-mx-auto ${props.className || ''}`} />
    </Row>
  );
}
